var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorngPosture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3996 6.90384L18.0895 4.72031C17.9833 2.09958 15.8181 0 13.1717 0C10.4581 0 8.25037 2.2072 8.2498 4.9207C8.24643 5.95008 8.48858 6.98044 8.95016 7.90036L9.5031 9.0023L5.52946 12.9759C4.86543 13.64 4.49976 14.5228 4.49976 15.4619V23.2969C4.49976 23.6852 4.81457 24 5.20288 24H7.31226V21.9936C7.31226 21.6053 7.62707 21.2904 8.01538 21.2904C8.40369 21.2904 8.71851 21.6053 8.71851 21.9936V24H13.764C14.1209 24 14.4212 23.7326 14.4624 23.3781L15.2579 16.5371C15.3707 15.5667 15.0708 14.5848 14.435 13.8431L12.7899 11.9237L13.6468 10.7812H15.9842C17.1473 10.7812 18.0936 9.83498 18.0936 8.67188V8.24119L19.0191 7.9327C19.4458 7.79044 19.6311 7.28958 19.3996 6.90384ZM8.71855 18.8295C8.71855 19.2178 8.40374 19.5326 8.01543 19.5326C7.62712 19.5326 7.3123 19.2178 7.3123 18.8295V17.4233C7.3123 17.0349 7.62712 16.7201 8.01543 16.7201C8.40374 16.7201 8.71855 17.0349 8.71855 17.4233V18.8295ZM10.3576 14.1143L9.36327 15.1087C9.08868 15.3833 8.64346 15.3833 8.36891 15.1087C8.09432 14.8341 8.09437 14.3889 8.36891 14.1143L9.36327 13.12C9.63787 12.8454 10.0831 12.8454 10.3576 13.12C10.6322 13.3946 10.6322 13.8397 10.3576 14.1143Z",
    fill: "#C59C37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorngPosture);
export default __webpack_public_path__ + "static/media/worng_posture.fe34cf06ee224306c4c000cf9638a917.svg";
export { ForwardRef as ReactComponent };